/**
 * News Feed Banner - Shows latest news below header (mobile-style)
 */

import React from 'react';
import { Typography } from 'antd';
import { ReadOutlined, DownOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import api from '../../config/api';
import './NewsFeedBanner.css';

const { Text } = Typography;

interface NewsItem {
  id: string;
  title: string;
  content: string;
  createdAt: string;
  user: { id: string; firstName: string; lastName: string };
}

interface NewsFeedBannerProps {
  channelId: string;
  onViewAll: () => void;
}

export const NewsFeedBanner: React.FC<NewsFeedBannerProps> = ({ channelId, onViewAll }) => {
  const { data: channelData } = useQuery(
    ['channel-details', channelId],
    () => api.get(`/api/chat/channels/${channelId}`).then(res => res.data),
    { enabled: !!channelId }
  );

  const { data: newsData } = useQuery(
    ['channel-news', channelId],
    () => api.get(`/api/chat/channels/${channelId}/news`).then(res => res.data),
    { enabled: !!channelId }
  );

  const channel = channelData?.channel;
  const news: NewsItem[] = newsData?.news || [];

  // Only show for groups, not DMs
  if (!channel || channel.type === 'direct') {
    return null;
  }

  const latestNews = news[0];

  return (
    <div className="news-feed-banner" onClick={onViewAll} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onViewAll()}>
      <div className="news-feed-banner-icon">
        <ReadOutlined />
      </div>
      <div className="news-feed-banner-content">
        <div className="news-feed-banner-meta">
          <Text strong className="news-feed-banner-label">NEWS</Text>
          {latestNews?.user && (
            <Text type="secondary" className="news-feed-banner-by">
              by {latestNews.user.firstName} {latestNews.user.lastName}
            </Text>
          )}
        </div>
        <div className="news-feed-banner-headline">
          {latestNews ? latestNews.title : 'No news yet'}
        </div>
      </div>
      <div className="news-feed-banner-action">
        <DownOutlined className="news-feed-banner-chevron" />
        <Text className="news-feed-banner-view-all">View All</Text>
      </div>
    </div>
  );
};
